export default {
  "Internal_Tools_B_Ejwk_Ynxz": "If you don’t want to use the debit note generated by {{brand_name}}, you can upload a debit note for the corresponding amount on this bill yourself, and the platform will review the file you upload.",
  "Internal_Tools_B_VhXm_dBVV": "Owner’s Signature",
  "Internal_Tools_3_HrdF_EKQU": "Click or drag to upload",
  "Internal_Tools_2_UVGE_CWXm": "Please enter the specified content",
  "Internal_Tools_B_POgT_ZnaL": "Product ID",
  "Internal_Tools_B_BxVt_bJek": "Total",
  "Internal_Tools_3_BaNN_xmlP": "Gas Station Discount (After) ({{currency_symbols}}) (≥0.05)",
  "Internal_Tools_B_baJJ_iGYw": "You will be able to download the file after confirmation.",
  "Internal_Tools_B_fCsH_wsFp": "Amount is unreasonable",
  "Internal_Tools_B_woQh_xwQt": "Please confirm that your email address is valid. If you need to update your email address, please contact the administrator.",
  "Internal_Tools_2_lodd_TcJh": "Total Original Price",
  "Internal_Tools_B_uuAb_JWOl": "Debit Note Information",
  "Internal_Tools_B_ZNHx_trjR": "Downloaded successfully",
  "Internal_Tools_3_xIIl_Twme": "Original Price ({{currency_symbols}})",
  "Internal_Tools_B_JlRY_rljm": "Approved",
  "GDriver_B_bBJO_VXlJ": "Notes",
  "Internal_Tools_B_eiVg_xzja": "Discount Type",
  "Internal_Tools_2_vAhn_Teln": "Click or drag to upload",
  "Internal_Tools_B_jTUw_mOnI": "Total Orders",
  "GDriver_Rate_WnXP_FNfu": "A negative amount indicates the Take Rate exceeds the platform subsidy, but no payment to the platform is required. This amount will automatically carry over to the next cycle.",
  "GDriver_B_eDuK_afie": "Real-time Orders",
  "Internal_Tools_B_jySx_dhBR": "Issued on",
  "Internal_Tools_B_WWXN_VFkc": "{{variable_Name}}",
  "Internal_Tools_3_foFN_zztM": "Confirm Uploaded Discounts",
  "Internal_Tools_B_Tnvm_bEIP": "Please enter the Gas Station Discount",
  "Internal_Tools_B_xiIL_TLct": "Please check your spam folder.",
  "Internal_Tools_2_kwTR_iKCb": "Download QR Code",
  "Internal_Tools_B_UaAZ_MOmJ": "Bank Account No.",
  "Internal_Tools_2_tnYP_zmjj": "Sep",
  "Internal_Tools_2_TJjb_Wvzj": "Total Gas Station Discount",
  "Internal_Tools_B_vlJT_UqQb": "City",
  "Internal_Tools_B_qWSm_gsCg": "Rejected",
  "Internal_Tools_B_znDH_qMZE": "Gas Station Discount cannot exceed the Original Product Price",
  "Internal_Tools_B_GzUD_pXnf": "Cancel",
  "Internal_Tools_2_VunY_IMzD": "Start time",
  "GDriver_B_fCnp_mBtP": "Amount After Discount per Liter",
  "Internal_Tools_B_MtXg_YOBx": "Are you sure you want to list this product? Once listed, the product will be shown to users on {{brand_name}} Refuel.",
  "Internal_Tools_2_yMpt_EUyT": "Unit Price After Discount",
  "Internal_Tools_3_KtGv_jKWY": "Import Discounts",
  "Internal_Tools_B_gPKb_TdEh": "Unable to save",
  "GDriver_B_ObZo_cyru": "Total amount after discount = Total amount before discount − Total discount amount",
  "Internal_Tools_B_VTCU_CeUB": "Attachment (Optional)",
  "Internal_Tools_B_myuj_LLtq": "Unable to clear changes",
  "Internal_Tools_B_fhzE_VyPH": "Confirm",
  "Internal_Tools_B_IMVU_okmF": "Save",
  "GDriver_Rate_Mkpg_QdjY": "Take Rate Strategy",
  "Internal_Tools_2_Ctnh_PCZG": "Gas Station Discount",
  "Internal_Tools_B_smNl_fJqE": "Rejected by {{brand_name}}",
  "GDriver_Rate_WEmP_UhBp": "This page displays associated orders from the past three months.",
  "Internal_Tools_B_rLLZ_yAjR": "Saved successfully",
  "GDriver_B_zaMj_EEIS": "Order Status",
  "Internal_Tools_2_fHjz_yFMU": "Expected Receivables",
  "GDriver_B_eFya_eIeE": "Original Price",
  "Internal_Tools_B_zfQV_KiFx": "The new Gas Station Discount is lower than the previous discount. A decrease in the discount may result in lower sales. Please confirm that you have entered the correct discount value.",
  "Internal_Tools_B_nRdi_lIgp": "Original Product Price",
  "Internal_Tools_B_aXSr_paiK": "Adjust",
  "Internal_Tools_B_FmOf_prqv": "Bank Name",
  "Internal_Tools_B_jmKa_NsET": "Confirm Submission",
  "GDriver_B_QzYe_htgo": "Total Amount Before Discount",
  "Internal_Tools_B_HXec_cozR": "Discount Last Updated at",
  "Internal_Tools_B_OZGf_eIJG": "Listed",
  "Internal_Tools_2_NMsR_VnbC": "Fuel Quantity",
  "Internal_Tools_B_ewyj_jVhQ": "Review",
  "Internal_Tools_B_CieE_fzIW": "Please select",
  "Internal_Tools_2_RzTq_mRBg": "Liters",
  "Internal_Tools_B_bgoN_mIid": "Cancel",
  "Internal_Tools_B_DDWp_neUq": "{{brand_name}} Settlement Amount",
  "Internal_Tools_B_tZsi_sztT": "Basic Information",
  "Internal_Tools_B_hlMU_cWRx": "Are you sure you want to delist this product? Once delisted, the product will not be shown to users on {{brand_name}} Refuel. Please exercise caution.",
  "Internal_Tools_2_KxKS_MqMX": "If any orders are missing, please click here.",
  "Internal_Tools_B_eMoB_KRAm": "Bill Management",
  "Internal_Tools_2_rCeC_qXKy": "Your amount adjustment (from {{bill_amount}} to {{bill_adjusted_amount}}) and the debit note you uploaded were rejected by {{brand_name}}. Please make changes based on the reason for rejection, then submit for confirmation again.",
  "Internal_Tools_3_eVmP_QNhY": "Invalid file format or header. Please re-upload.",
  "Internal_Tools_B_sElL_adaZ": "Company Name",
  "GDriver_B_pcAA_HWoB": "Calculating",
  "Internal_Tools_B_GaWI_nvTf": "{{Gas_Station_Name}}’s bill ({{Bill_Periods}}) was successfully paid to your account. Amount: {{Bill_adjusted_amount}}. Please confirm.",
  "Internal_Tools_B_sFAV_iacx": "Cancel",
  "Internal_Tools_B_gans_zqgx": "To help us serve you better, please let us know why you want to delist this product. Thank you!",
  "Internal_Tools_2_CeJk_uQAq": "Enter specific reason(s)",
  "Internal_Tools_B_UilM_nfcx": "Item Description",
  "Internal_Tools_2_uwVq_MMJw": "Please upload a file in .pdf, .jpeg, .jpg, .png or .xlsx format (up to 10 MB)",
  "Internal_Tools_B_vmUO_nwSd": "Platform will adjust the actual price received by the refueling user and bear the difference between the Total Discount Amount and the Gas Station Discount.",
  "Internal_Tools_2_MTMo_BaMI": "Apr",
  "Internal_Tools_B_Hsqp_HMYm": "Gas Station Action:",
  "Internal_Tools_B_gOmi_rvrr": "Debit Note",
  "Internal_Tools_B_KXEV_WsEc": "Confirm Clear Changes",
  "Internal_Tools_2_AdFu_XwYF": "Once exited directly, your adjustment to the amount will be cleared. Do you want to save the content you entered before exiting?",
  "Internal_Tools_B_jAUX_xIGC": "Bill Generation",
  "Internal_Tools_B_dgQy_EcYg": "For",
  "GDriver_Rate_Qnme_nHUC": "View main bill",
  "Internal_Tools_2_RNZQ_cXCd": "You adjusted {{num}} order(s). After adjustment, the additional settlement amount of the bill is {{{adjustment_amount_orders}}}.",
  "Internal_Tools_B_LXmx_VUXh": "Save",
  "GDriver_Rate_kqZa_VLnH": "Missing Orders",
  "Internal_Tools_3_IpMC_owwp": "Please contact Customer Service during service hours",
  "Internal_Tools_2_zdDd_lJmX": "Entered amount must be less than the Total Original Price",
  "Internal_Tools_2_CnTD_lDFG": "No data",
  "Internal_Tools_B_ntHL_WvCO": "Awaiting confirmation",
  "Internal_Tools_B_BuUG_bfZR": "To view more records, please go to the {Discount Changelog}",
  "Internal_Tools_2_ThRd_xnHT": "Day",
  "Internal_Tools_2_lYFD_lpHi": "Jul",
  "GDriver_Rate_gAPX_UqhX": "Adjusted Bill",
  "Internal_Tools_2_nitD_IURE": "{{brand_name}} Settlement Amount (After Adjustment)",
  "Internal_Tools_B_cmzd_RyDx": "Paid by {{brand_name}}",
  "Internal_Tools_B_HGyM_msoC": "Operator",
  "GDriver_B_FKZH_bmer": "Product name",
  "Internal_Tools_2_uHFh_xZXJ": "Order Quantity",
  "Internal_Tools_B_HMKF_pPXI": "Upload Debit Note Yourself (Optional)",
  "GDriver_B_AIST_uhIx": "Total Liters",
  "Internal_Tools_2_MwJt_SFwg": "Notes",
  "Internal_Tools_B_MSqS_OLZh": "Bank Account Type",
  "Internal_Tools_B_NorW_yQid": "Feedback from {{brand_name}}: The adjustment request was approved. Please confirm.",
  "Internal_Tools_2_qMwU_rvhb": "Year",
  "GDriver_B_HAsu_pUhW": "Refunded",
  "GDriver_B_fgYV_RobR": "Total Discount Amount",
  "Internal_Tools_6_VKVq_bQAl": "Attention",
  "Internal_Tools_B_cffn_cmkL": "Download Bill Details",
  "GDriver_B_KVkL_ZHjF": "Last 7 days",
  "Internal_Tools_B_elSJ_gIZG": "Please upload a file in .pdf, .jpeg, .jpg or .png format (up to 10 MB)",
  "Internal_Tools_2_hhOc_JJAW": "Start",
  "Internal_Tools_B_Fngc_WSSS": "Gas Station Discount",
  "Internal_Tools_B_MBuz_Ymtp": "Beneficiary Name",
  "Internal_Tools_B_fDkS_eMyr": "Operator",
  "Internal_Tools_2_CrYy_JcNy": "Scan the QR code with your phone",
  "GDriver_Rate_XEUc_iloC": "Specific Reason",
  "Internal_Tools_2_NLCP_rEFO": "The Review feature is not available on mobile devices. Please use the PC version.",
  "Internal_Tools_2_pHZw_WxBd": "Original Price",
  "Internal_Tools_2_NgEj_cmVx": "Sec",
  "Internal_Tools_2_kjSs_qYzP": "Oct",
  "Internal_Tools_B_wUPq_CDsX": "Bank Account No.:",
  "Internal_Tools_B_cclU_VMMo": "Branch Code:",
  "GDriver_Rate_Vgyp_nqsD": "Order Quantity",
  "Internal_Tools_2_BecI_qaZY": "End",
  "Internal_Tools_B_MEDg_tikP": "Basic Information",
  "Internal_Tools_2_kUxV_iMJC": "Time Range",
  "GDriver_B_Gxva_EpVj": "Completed",
  "Internal_Tools_2_JYyb_uJky": "Sign Out",
  "Internal_Tools_B_HPAz_LoqE": "Reason for rejection by {{brand_name}}: {{variable_name}}",
  "Internal_Tools_B_iiVf_pSOO": "Product Discount Adjustment Details",
  "Internal_Tools_B_PYRp_eEhi": "Download Bill Summary via Email",
  "Internal_Tools_B_JKwQ_LMMp": "Gas Station Name",
  "Internal_Tools_B_NrRO_hyjF": "City – State",
  "Internal_Tools_B_eXuC_kQPR": "Other",
  "Internal_Tools_2_xUdt_pOMS": "Total Fuel Quantity",
  "Internal_Tools_B_Kcmr_GPux": "Debit note is invalid",
  "Internal_Tools_B_JBUV_TzRT": "Are you sure you want to clear your changes? Once confirmed, your changelog will be cleared.",
  "Internal_Tools_B_cWRX_eefe": "Bill Amount",
  "Internal_Tools_B_ABGx_NgcF": "{{appendix}}",
  "Internal_Tools_3_hYrd_MHvK": "Product Name",
  "Internal_Tools_B_GZrT_BIFB": "Total Fuel Quantity (Liters)",
  "Internal_Tools_2_Xueq_krcz": "Adjustment Amount",
  "Internal_Tools_2_MhRN_FNUA": "Total Liters of Liquid Fuel",
  "Internal_Tools_2_ftnF_zZMU": "submitted missing order(s)",
  "GDriver_Rate_zQlW_UZCR": "Current Period Amount",
  "Internal_Tools_B_hWZz_Swrm": "Product Listing Confirmation",
  "Internal_Tools_B_AeyK_bIak": "List",
  "Internal_Tools_2_dgvn_fQpU": "Please upload supporting evidence for the missing order(s) (in .xlsx format)",
  "Internal_Tools_3_GQxF_vack": "No.",
  "Internal_Tools_2_eBtC_jSgY": "End time",
  "GDriver_Rate_ujyz_RSOz": "Proof of Missing Order",
  "Internal_Tools_B_wFVO_wUGQ": "Mobile Number",
  "Internal_Tools_B_owWu_mwVa": "Address",
  "Internal_Tools_B_gYZs_ulOj": "Last Updated at",
  "Internal_Tools_B_VLNO_dwPV": "Clear Changes",
  "Internal_Tools_B_yuff_FSjp": "Cancel",
  "Internal_Tools_B_mbwq_mnym": "{{Gas_Station_Name}}’s bill ({{Bill_Periods}}) was rejected by {{brand_name}}. Please go to {{brand_name}} Refuel for confirmation.",
  "GDriver_Rate_vcNN_TOwL": "View adjusted bill",
  "Internal_Tools_2_pACZ_Yzam": "Up to {{num}} orders can be adjusted",
  "Internal_Tools_B_OBgN_mTrt": "Delist",
  "Internal_Tools_B_lxML_RcGh": "Reason for Delisting",
  "Internal_Tools_2_XHWq_gRnu": "Show Filters",
  "Internal_Tools_2_oVai_vFAT": "{{brand_name}} Settlement Amount",
  "GDriver_Rate_LQtQ_IRrX": "Beginning Amount",
  "Internal_Tools_2_VmKe_ukvq": "Upload failed",
  "Internal_Tools_2_nHHF_Crlf": "The debit note you uploaded was rejected by {{brand_name}}. Please make changes based on the reason for rejection, then submit for confirmation again.",
  "Internal_Tools_6_UFDK_QNkM": "Are you sure you want to adjust the product discount for this gas station? Once confirmed, the new discount will become valid as soon as the gas station is listed.",
  "Internal_Tools_2_XuZF_XpcU": "Unable to save. Please try again.",
  "Internal_Tools_B_mIlH_Fkgh": "Actions",
  "GDriver_B_mKhM_HPiy": "Cancelled",
  "Internal_Tools_B_nBFs_LXko": "If the information is incorrect, please contact our sales team at {{sales_email}} to request a correction.",
  "Internal_Tools_3_NlPw_QlkA": "High discount",
  "Internal_Tools_B_btRf_kJeN": "Total users with refueling orders under the selected conditions (only includes users with successfully transacted orders that were not cancelled)",
  "Internal_Tools_B_Ajtt_rxuw": "Bank Name:",
  "Internal_Tools_B_UOfz_hTHC": "View",
  "Internal_Tools_B_qxrM_NiCE": "Profit is too low for the gas station to offer discounts",
  "Internal_Tools_B_ljFB_DAJr": "Please enter the Gas Station Discount below, then click the List button to list the product.",
  "Internal_Tools_2_aRCX_mimf": "“Cancelled” orders are filtered out",
  "Internal_Tools_B_AWqL_aCAL": "Gas Station Tax ID",
  "Internal_Tools_B_SxmG_vBav": "{{Gas_Station_Name}}’s bill ({{Bill_Periods}}) was paid. Please confirm.",
  "Internal_Tools_3_TwYi_hyXj": "Amount Adjusted?",
  "Internal_Tools_B_eYAC_Clpm": "Adjusted the amount from {{bill_amount}} to {{bill_adjusted_amount}}",
  "Internal_Tools_B_hORS_vRXF": "Delisted",
  "Internal_Tools_B_biCt_AXoR": "Upload a file in .pdf, .jpeg, .jpg or .png format only",
  "Internal_Tools_B_jDZP_kDzC": "Gas Station Discount (Before Change)",
  "Internal_Tools_B_Ghxe_pCWK": "Valid",
  "Internal_Tools_2_TEGY_SONK": "Gas Station Unit Discount",
  "Internal_Tools_B_MCil_Xcno": "Item",
  "Internal_Tools_B_bNIZ_hAGP": "Enter text",
  "GDriver_B_apbe_dntZ": "Gas Station Name",
  "Internal_Tools_B_Pmry_OGIf": "Deposit Details",
  "Internal_Tools_B_fZhR_srgn": "Stamp",
  "Internal_Tools_3_SOIx_QzGa": "Product ID",
  "Internal_Tools_B_jpOd_zpOd": "Issued/Uploaded at",
  "Internal_Tools_B_WuVw_UhVj": "Debit Note ID",
  "Internal_Tools_2_QPsS_gHnw": "Cancel",
  "GDriver_B_CkMV_hWxl": "This Week",
  "Internal_Tools_B_Bkts_QgGl": "Reason: {{reason}}",
  "Internal_Tools_B_TGdl_pQYC": "Price",
  "Internal_Tools_Ops_ZrXX_jLfJ": "Total of {{order_quantity}} entries",
  "Internal_Tools_B_Xddd_srny": "Product Management",
  "Internal_Tools_B_EAzs_ZGvU": "Debit Note",
  "Internal_Tools_3_fqmg_VDbw": "Confirm and Upload",
  "Internal_Tools_B_XWSG_ifsw": "Recent Changelog",
  "Internal_Tools_2_YBkJ_wHPL": "Min",
  "GDriver_B_JAhN_lxfe": "Total Amount After Discount",
  "Internal_Tools_B_ODcX_VDxG": "Action",
  "Internal_Tools_B_KTZQ_wBFq": "Actions",
  "Internal_Tools_B_upRN_xOJy": "Issued/Uploaded by",
  "Internal_Tools_B_sCvg_DfYw": "Billing Period",
  "Internal_Tools_B_JAZc_kfnw": "Rejected",
  "Internal_Tools_B_EzRf_TXVr": "Didn’t receive the email?",
  "Internal_Tools_B_elge_fQzz": "Discount Adjustment Confirmation",
  "Internal_Tools_B_wzLs_Zbqj": "Total refueling orders under the selected conditions (only includes successfully transacted orders that were not cancelled)",
  "GDriver_Rate_CNuf_gFsJ": "{{Platform_name}} Take Rate",
  "GDriver_B_aseD_RLUl": "Discount Code",
  "GDriver_B_JGKl_aMeG": "Account Statements",
  "Internal_Tools_6_Knpn_VdKB": "Are you sure you want to display this product? Once confirmed, the product will appear in {{brand_name}} Refuel as soon as the gas station is listed.",
  "Internal_Tools_2_SAIb_RpwU": "Confirm Exit",
  "Finance_120version_All_XvPp": "All",
  "GDriver_B_duAf_AXjt": "Order status",
  "Internal_Tools_B_xfZE_YVTX": "{{Gas_Station_Name}}’s bill ({{Bill_Periods}}) was rejected by {{brand_name}}. Please confirm.",
  "Internal_Tools_B_HlmN_NmVE": "Operator Email",
  "Internal_Tools_B_IdjN_nrct": "View Debit Note",
  "Internal_Tools_B_PuzK_uAgA": "Total Discount",
  "Internal_Tools_B_rVeY_zhxF": "Display Status",
  "Internal_Tools_2_swod_ShaV": "Nov",
  "GDriver_Rate_qAKf_Tuxy": "Settlement Amount",
  "GDriver_B_ypBU_eWTX": "Total Orders",
  "GDriver_B_voCc_twWK": "Total Users",
  "Internal_Tools_B_iuIG_bARf": "List",
  "GDriver_B_hxEf_LgnF": "Download Detailed Bill",
  "Internal_Tools_B_maAi_LDaH": "Confirm",
  "Internal_Tools_B_yKrW_kCRv": "Uploaded debit note",
  "Internal_Tools_B_KcBD_VdDF": "Total Amount",
  "Internal_Tools_2_dhrn_UOGT": "Hide Filters",
  "Internal_Tools_B_eswZ_toaj": "Please confirm {{Gas_Station_Name}}’s bill ({{Bill_Periods}})",
  "Internal_Tools_4_Cwym_IJSI": "Only .xlsx files are supported",
  "Internal_Tools_2_ijcp_zTQW": "Select Order(s) to Adjust Amount",
  "GDriver_B_BtUy_wEbU": "Total Discount Amount",
  "Internal_Tools_4_FPhj_TwAr": "Attachment Information for Missing Orders",
  "Internal_Tools_B_ljtx_sZET": "Product Delisting Confirmation",
  "Internal_Tools_B_scNd_qcZP": "Completed",
  "Internal_Tools_B_xSlQ_mCao": "Gas station action: {{variable_name}}",
  "Internal_Tools_3_kwOM_UZuX": "CNPJ",
  "GDriver_B_gltl_Hlxo": "Gas station name",
  "Internal_Tools_B_zqAk_QFls": "Only one file can be uploaded",
  "Internal_Tools_2_ShWE_pqHC": "Feb",
  "Internal_Tools_B_rSBU_GsMk": "Bank Payment",
  "Internal_Tools_B_fudE_UQpX": "Please confirm whether the following information is correct:",
  "Internal_Tools_B_bgHa_HtAx": "Debit Note History",
  "GDriver_B_plYK_TBWO": "This Month",
  "Internal_Tools_B_fEFC_wWrr": "Bill Status",
  "GDriver_Rate_Ypvy_hqGY": "Amount Adjustment Details",
  "Internal_Tools_B_STXC_iwsY": "Reconciliation and Settlement Details",
  "Internal_Tools_B_SPnJ_IQAe": "Discount Management",
  "GDriver_Rate_TJDL_AuGR": "Associated Bills List",
  "Internal_Tools_2_Nqhz_aeKd": "The bill amount you entered is the same as the amount calculated by the platform. Please modify.",
  "Internal_Tools_B_YhSM_fNbO": "Tax ID:",
  "Internal_Tools_B_HmDv_lOyc": "Uploaded successfully",
  "Internal_Tools_B_BrTt_fcQx": "Email Address",
  "Internal_Tools_2_aHcj_MNUx": "Total Volume of Gaseous Fuel",
  "Internal_Tools_B_dsMv_ZMMu": "The new Gas Station Discount is lower than the current platform limit ({{lower_limit}}) and cannot be saved. Please check and re-enter.",
  "Internal_Tools_B_Nckm_MRzP": "Vendor approved the bill amount on {{brand_name}} Refuel at {{time}}",
  "GDriver_B_SXwK_HWoB": "Total Amount Before Discount",
  "Internal_Tools_B_SahY_dqBb": "Branch Code",
  "GDriver_B_kmNL_caEY": "Discount Level When Refueling",
  "GDriver_B_gElW_SXdK": "Total Amount",
  "Internal_Tools_B_WGhe_oKSS": "Technical reason (network/electric/RMS)",
  "Internal_Tools_B_qbYe_OgQa": "(calculated by {{brand_name}})",
  "GDriver_B_mSPV_rbLY": "You do not have permission to access this page. Please contact the system administrator.",
  "Internal_Tools_2_VPzK_SlSn": "May",
  "Internal_Tools_2_tepY_hnPO": "Available daily from {{time_start}} to {{time_end}}",
  "Internal_Tools_B_RxoO_bhVS": "Initiated Gas Station Discount adjustment",
  "Internal_Tools_B_oGAj_HAts": "Company Name",
  "Internal_Tools_3_Okwr_nrog": "Invalid content. Download file for details.",
  "Internal_Tools_B_kMWu_eiOM": "Sent Successfully!",
  "Internal_Tools_Ops_vEHa_XFxU": "Tax ID",
  "Internal_Tools_2_WOcZ_xmgT": "Up to {{num}} file(s) can be uploaded",
  "Internal_Tools_2_lSBW_srOU": "The Adjust feature is not available on mobile devices. Please use the PC version.",
  "Internal_Tools_B_aBZb_ubgd": "Detailed Product Name",
  "Internal_Tools_B_fKyZ_jQjs": "Discount Tactic",
  "Internal_Tools_B_npwb_kifs": "If you think the settlement amount is incorrect, please click {here} to adjust it.",
  "Internal_Tools_B_vtbb_fwKe": "Report will be sent to your email address {{email_address}}.",
  "Internal_Tools_2_sVTx_zDXt": "Gas Station Receivables − {{brand_name}}’s Calculation",
  "Internal_Tools_2_fLkn_zUya": "Order ID",
  "Internal_Tools_2_guyK_dNWP": "Hr",
  "Internal_Tools_B_NrnD_CueJ": "File size limit is 10 MB",
  "Internal_Tools_2_DgKa_MWcm": "Mar",
  "Internal_Tools_B_roDY_yNHt": "Changes cleared successfully",
  "Internal_Tools_B_LhVI_fQhq": "{{reason}}",
  "Internal_Tools_B_bNjt_LhgO": "Product Name",
  "Internal_Tools_B_klis_ZshW": "No.",
  "Internal_Tools_B_mVaF_oiOh": "Since this is caused by the platform’s dynamic adjustment, no payment is required.",
  "Internal_Tools_B_ljZA_uzFp": "Client ID",
  "Internal_Tools_2_ShSC_iPXl": "Please upload a file",
  "Internal_Tools_B_qIkJ_vecB": "Gas Station Discount",
  "Internal_Tools_B_btLV_laDf": "Review History",
  "Internal_Tools_2_dkIt_zOwG": "Please complete the missing order details and the additional amount expected to be settled by {{brand_name}}",
  "Internal_Tools_2_nsxA_ILyQ": "Original {{brand_name}} Settlement Amount",
  "GDriver_B_OgXv_iCAL": "Total",
  "GDriver_B_GCvq_HEoF": "Total liters of all refueling orders under the selected conditions",
  "Internal_Tools_B_sGXH_MbOC": "View",
  "Internal_Tools_2_GSUg_zEJU": "Total liters of liquid fuel of all refueling orders for the selected conditions",
  "Internal_Tools_6_YUwb_Jftq": "This product is not activated. Unable to modify.",
  "Internal_Tools_3_qadq_ftID": "Upload",
  "GDriver_Rate_kKDM_ZGLr": "Problematic Orders",
  "GDriver_Rate_HfEU_JVUS": "Services Fee Charged",
  "Internal_Tools_B_SCdD_gYeo": "Completed",
  "Internal_Tools_2_KVNS_Tidn": "Jan",
  "GDriver_B_QGRk_fEQb": "Download Bill Summary",
  "Internal_Tools_B_alkr_LDhX": "Fixed percentage discount",
  "GDriver_B_gBCW_tqrc": "Liters",
  "GDriver_B_uGTO_zzvy": "Order ID",
  "Internal_Tools_3_mbZw_bLfk": "Step 1: Download Template Based on Filter",
  "Internal_Tools_B_Pfxu_ZJtI": "Total",
  "GDriver_Rate_lICZ_WYxq": "Closing Amount",
  "Internal_Tools_3_AkBo_IAuy": "Cancel",
  "GDriver_Rate_zCyR_AFnE": "The bill amount has been adjusted to {{adjusted_amount}}",
  "Internal_Tools_3_Famx_vWjX": "Download Template",
  "Internal_Tools_B_FGcc_qKjk": "Cancel",
  "Internal_Tools_B_Hiye_IHzm": "Adjustment saved successfully",
  "GDriver_B_puJr_wfVl": "Account has been frozen. Please contact the system administrator.",
  "Internal_Tools_3_LLVV_gEyO": "Gas Station Discount (Before) ({{currency_symbols}})",
  "Internal_Tools_2_AzpT_hWwx": "Quick Options",
  "Internal_Tools_3_HfRl_hfLy": "Max 1,000 entries per upload. Please re-upload.",
  "Internal_Tools_B_lKPj_Cfrr": "Your report will arrive at your email address {{email_address}} later.",
  "Internal_Tools_2_HapJ_nsTk": "Aug",
  "Internal_Tools_2_jfyZ_sGtA": "Dec",
  "Internal_Tools_B_sYEO_YiqD": "Approved",
  "Internal_Tools_B_dARX_ILFp": "Price After Discount",
  "Internal_Tools_2_SKHb_kzAe": "Product name",
  "Internal_Tools_B_HxGE_tKzV": "Gas Station Discount (After Change)",
  "Internal_Tools_B_SOMA_BAzh": "Discount Difference",
  "Internal_Tools_2_ZlCC_JcRC": "Exit",
  "Internal_Tools_B_jbbQ_xdOx": "Reason: {{reason}}",
  "Internal_Tools_2_KOqv_srKp": "Customer Support",
  "Internal_Tools_B_EnBP_ecCZ": "Download",
  "Internal_Tools_B_ooyJ_mlNY": "Gas Station Review",
  "Internal_Tools_2_inUB_pEQn": "Save and Exit",
  "Internal_Tools_2_nbUx_lwXP": "Period",
  "GDriver_B_cjbU_mTvI": "Gas Station Discount",
  "GDriver_B_WUOr_ceCL": "Data Center",
  "Internal_Tools_B_Gzdd_AKbU": "Gas Station Adjustment Amount",
  "Internal_Tools_B_MhcJ_rfQv": "Product Discount Tactic Details",
  "GDriver_Rate_loVu_PxhD": "View Associated Bills",
  "Internal_Tools_B_ajlo_HnqP": "Action Log",
  "Internal_Tools_B_muPj_LeXe": "{{Brand_Name}} Adjustment",
  "Internal_Tools_B_iLJS_uUwa": "Product listed successfully",
  "Internal_Tools_B_bNEi_MfAw": "Cancel",
  "Internal_Tools_B_HOMP_Jysk": "Product delisted successfully",
  "Internal_Tools_B_HHxf_GgTF": "Time",
  "Internal_Tools_3_SBhz_EZXw": "Gas Station Name",
  "Internal_Tools_2_oDlf_fVsf": "Order Time",
  "Internal_Tools_2_onjK_xaqD": "Total volume of gaseous fuel of all refueling orders for the selected conditions",
  "GDriver_Rate_FmgF_CgeQ": "1. Fixed field value: Generated based on the condition selected in the filter box. If you select “All”, the field value will become “All”; if you select a particular condition, the corresponding information of that option will be shown in the list.",
  "Internal_Tools_2_eyOs_aAPw": "Attachment Information",
  "Internal_Tools_2_GaFz_pQZZ": "Please filter the order you think has an amount-related issue, and enter the expected amount.",
  "Internal_Tools_B_ceeV_dRMo": "Payment Period",
  "Internal_Tools_B_upfK_Vzsc": "Please enter",
  "Internal_Tools_2_mmuK_qILh": "Liquid",
  "Internal_Tools_B_lWRy_tGTo": "Date",
  "Internal_Tools_B_zpbB_XOiB": "Product currently unavailable",
  "Internal_Tools_2_IlQz_mEGK": "Original Unit Price",
  "Internal_Tools_B_Hfjm_aSzt": "Cancel",
  "Internal_Tools_B_ZWnL_NxIT": "Description",
  "Internal_Tools_B_SECS_XFym": "Bill confirmed successfully",
  "GDriver_Rate_VFLy_nWaE": "The bill amount has not changed. Please make adjustments before submitting.",
  "Internal_Tools_B_iRuS_vbPU": "Under {{brand_name}} review",
  "Internal_Tools_B_lmzi_AdZe": "Reason for rejection by {{brand_name}}: {{reason}}",
  "Internal_Tools_B_jGdF_dNpY": "{{Gas_Station_Name}}’s bill ({{Bill_Periods}}) was pushed to {{brand_name}} Refuel, and the bill amount is {{Bill_Amount}}. To ensure that you receive your payment on time, please confirm as soon as possible.",
  "Internal_Tools_B_yzcd_HgnA": "In progress",
  "GDriver_B_RWAU_ZILl": "Terms and Conditions",
  "Internal_Tools_B_IYOZ_iwAq": "Action Time",
  "Internal_Tools_B_FKdd_ahtc": "This debit note was automatically generated by {{brand_name}}.",
  "Internal_Tools_B_Dlhh_BgJZ": "Download Detailed Bill via Email",
  "Internal_Tools_B_EGqI_BLrf": "Review Log",
  "Internal_Tools_2_NGLr_hhOD": "The View feature is not available on mobile devices. Please use the PC version.",
  "Internal_Tools_B_NVMK_FtoH": "Gas station",
  "Internal_Tools_B_etLT_XTcj": "(adjusted by gas station)",
  "GDriver_B_eSPa_nCyq": "{{Page_num}} / page",
  "GDriver_Rate_xJny_zMFD": "No data available",
  "Internal_Tools_B_zluz_RSQE": "{{brand_name}} Refuel Program",
  "Internal_Tools_B_IRRc_hZIm": "Invalid",
  "Internal_Tools_B_hRqn_QiwT": "Billing Information",
  "Internal_Tools_3_thwC_VgKl": "Please scroll through all entries before confirmation",
  "Internal_Tools_B_BRqr_VajR": "Bill Adjustment Item",
  "Internal_Tools_3_Cdzx_KDff": "Monday to Friday 8:00 am – 6:00 pm",
  "Internal_Tools_3_AUkL_uYJd": "Step 2: Upload Template File",
  "GDriver_B_VMvB_MrxF": "Date",
  "Internal_Tools_B_ZNba_eOJt": "(Up to five records can be displayed)",
  "Internal_Tools_B_WZtb_VmSM": "No.",
  "Internal_Tools_3_QEFE_kxrV": "Price(s) after discount of {{number}} product(s) exceed(s) 25% of the original price(s). Please confirm again.",
  "GDriver_B_nwAp_Bahp": "Account does not exist. Please use another account.",
  "Internal_Tools_B_aTmx_JssU": "{{brand_name}} Review",
  "Internal_Tools_B_SidT_WnWJ": "Confirm",
  "GDriver_Rate_viTB_cjDd": "Notes",
  "Internal_Tools_2_mxFS_VTNj": "Liquid fuel is measured in liters. Gaseous fuel is measured in cubic meters.",
  "Internal_Tools_B_ZURF_RCND": "Are you sure you want to save this Gas Station Discount adjustment? Once saved, the new discount will become valid immediately.",
  "Internal_Tools_B_tPhY_EMCr": "Bill ID",
  "GDriver_Rate_mEjS_xsaH": "Payment Amount",
  "Internal_Tools_3_eUjQ_yIOl": "Use Template to Import Discounts",
  "Internal_Tools_B_OLQx_vawS": "Indicates whether the product is shown to users on {{brand_name}} Refuel",
  "Internal_Tools_B_ZHCN_sXeT": "Cancel",
  "GDriver_B_qyne_lALc": "User Name",
  "Internal_Tools_B_tILQ_yJAG": "Cancel",
  "Internal_Tools_2_lyyB_vPzq": "Your amount adjustment (from {{bill_amount}} to {{bill_adjusted_amount}}) was rejected by {{brand_name}}. Please make changes based on the reason for rejection, then submit for confirmation again.",
  "Internal_Tools_B_RNhD_qhCK": "Reconciliation and Settlement",
  "Internal_Tools_B_GEJX_hrvH": "Please enter the reason for delisting",
  "Internal_Tools_B_gDNW_jILR": "{{brand_name}} platform",
  "Internal_Tools_2_YPte_IwOE": "Gaseous",
  "Internal_Tools_2_aeNy_MYVh": "Month",
  "Internal_Tools_2_Pafp_fpyb": "Please upload order details or other documentation to support the adjustment.",
  "Internal_Tools_3_hDav_blKk": "Download",
  "Internal_Tools_B_ooUz_fFmX": "Actions",
  "Internal_Tools_2_RxEZ_ESeX": "Please enter the expected settlement amount post adjustment",
  "Internal_Tools_B_GzFj_Nlnu": "Gas Station Adjustment Amount",
  "Internal_Tools_B_qtns_OWdE": "Quantity",
  "Internal_Tools_B_pLXk_EZcF": "This is an estimated price. The actual price paid by users after discount may vary based on adjustments by the {{brand_name}} platform.",
  "GDriver_B_tuUz_ZGks": "Last Week",
  "GDriver_B_QaJz_nHMx": "Bills",
  "Internal_Tools_B_btqY_oyra": "Discount Changelog",
  "Internal_Tools_2_QKQx_ephy": "View on Phone",
  "Internal_Tools_4_fhfu_QNpo": "Please upload an .xlsx file (up to 10 MB)",
  "GDriver_Rate_pKeD_TLlw": "{{Platform_name}} Discount",
  "Internal_Tools_B_rJTV_GFwt": "Edit",
  "Internal_Tools_B_oVBD_xPFJ": "Delist",
  "Internal_Tools_2_ANJX_viUn": "Total After Discount",
  "Internal_Tools_2_Yexl_qwtW": "adjusted {{num}} order(s)",
  "Internal_Tools_B_XADb_rGKq": "Status",
  "Internal_Tools_B_FcHg_Nkhf": "{{brand_name}} platform",
  "Internal_Tools_B_jMpQ_MhBZ": "Last updated at: {{time}}",
  "Internal_Tools_B_vETe_JGNb": "Fixed amount discount",
  "Internal_Tools_B_ZToB_JbPm": "Send",
  "GDriver_B_BJTU_VFFp": "Total amount of all refueling orders after discounts under the selected conditions",
  "Internal_Tools_B_XbZk_Lagw": "Item(s) Denied:",
  "Internal_Tools_B_atoO_Ssnn": "Edit",
  "GDriver_B_SWsZ_SxEV": "Total discount amount = {{Brand_Name}} discount + Gas station discount",
  "GDriver_B_LRmo_qQTO": "{{Brand_Name}} Discount",
  "GDriver_B_MyJy_Qfir": "Total Amount After Discount",
  "Internal_Tools_2_uYtG_HGQZ": "Select Time",
  "GDriver_B_OZRC_vJMU": "Sign Out",
  "Internal_Tools_2_vYnH_dgVv": "Your request was rejected by {{brand_name}}. Please make changes based on the reason for rejection, then submit for confirmation again.",
  "Internal_Tools_2_ANMs_tYaS": "Jun",
  "Internal_Tools_B_qOau_cxQf": "Order Report"
}